/**
 * Global Data Device Type mapper
 * @param {Object} data - cms response data
 * @return {Object} the normalized data
 */

export default (data) => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    contentType: data.contentType || '',
    name: data.name || ''
  }
}
